export default __webpack_public_path__ + "static/media/banner2.3d0915e9.png";